import BigWinAnimations from 'core/components/wins/BigWinAnimations'
import DatGUI from 'core/GUI/DatGUI'
import Base64 from 'core/render/Base64'
import Managers from 'logic/Managers'
import Models from 'logic/Models'
import { version } from 'settings/custom/build'
import { isNewBigWin } from 'settings/custom/win'
import { log } from 'utils/Logger'
import { sendSignal } from 'utils/SendSignal'

export default class Game {
  constructor() {
    this.application = {}
    this.assets = {}
    this.assets.textures = []
    this.models = new Models()
    this.managers = new Managers()
    this.base64 = new Base64('logo')
    this.gui = new DatGUI()
    this.bigwin = {}
    this.parameter = {}
    this.parameter.nitro = false
    this.sendSignal = sendSignal
    this.version = version

    log(`Tag:${this.version}`, 'WARNING')

    if(isNewBigWin) {
      this.bigwin.manager = new BigWinAnimations()
    }

  }

  getTextureFromAtlases(name) {
    const textures = this.assets.textures
    for (const atlas of textures) {
      if (name in atlas) {
        return atlas[name]
      }
    }
    log(`Couldn't find texture ${name}`, 'WARNING')
    return null
  }
}
